/* eslint-disable import/no-anonymous-default-export */
import OpenWindow from "../OpenWindow";

const handleOpenWindow = (pubMedId) => {
    let url = `https://www.rightfind.com/vlib/order/orderform.aspx?ClientId=60&qlu=${pubMedId}`
    OpenWindow(url)
}
export default function (props) {
    const {
        pubMedId
    } = props
    return (

        <div
            className="action-badge"
            data-color="Gray"
            data-icon-left="true"
            data-icon-right="false"
            data-size="S"
            data-style="Light background"
            onClick={e => handleOpenWindow(pubMedId)}
        >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" xlinkTitle="">
            <title>You have the digital rights to use the full document associated with this citation for any internal purpose. For other usages, including External Reactive Use, Proactive Use, Transmission to a Regulatory Agency, or Special Orders of charts, tables, etc., click on this option to order via RightFind and select the appropriate usage option.</title>
                <g clip-path="url(#clip0_676_2117)">
                    <path d="M8.00016 10.6667V8.00001M8.00016 5.33334H8.00683M14.6668 8.00001C14.6668 11.6819 11.6821 14.6667 8.00016 14.6667C4.31826 14.6667 1.3335 11.6819 1.3335 8.00001C1.3335 4.31811 4.31826 1.33334 8.00016 1.33334C11.6821 1.33334 14.6668 4.31811 14.6668 8.00001Z" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </g>
                <defs>
                    <clipPath id="clip0_676_2117">
                        <rect width="16" height="16" fill="white" />
                    </clipPath>
                </defs>
            </svg>

            <div className="badge-text">Order for RightFind for additional usage</div>
        </div>
    )
}